import React from "react";
import "./Homepage.css";
import { TypeAnimation } from "react-type-animation";

const HomePage = () => {
  return (
    <div className="HomePage">
      <div className="flex1">
        <div className="intro-para">
          <div className="info-div">
            <br></br>
            <h3> Hello, My name is</h3>
            <h1 style={{ fontSize: "4.5rem", fontWeight: "bolder" }}>Avit</h1>
            <h3> Talk's About</h3>
            <div>
              <TypeAnimation
                cursor={true}
                sequence={[
                  "Full Stack Development",
                  1000,
                  "Python Development",
                  1000,
                  "Machine Learning",
                  1000,
                  "Production Ready Applications",
                ]}
                repeat={Infinity}
                wrapper="h2"
                className="typing-text"
              />
            </div>
            <p style={{ fontWeight: "bolder" }} className="Container">
              Highly motivated software engineer with a strong background in
              developing . Tech Ethusiast , Quick Learner
            </p>
          </div>
        </div>
        <div className="img-div">
          <div class="macbook">
            <div class="inner">
              <div class="screen">
                <div class="face-one">
                  <div class="camera"></div>
                  <div class="display">
                    <div class="shade"></div>
                  </div>
                  <span>MacBook Air</span>
                </div>
                <title>Layer 1</title>
              </div>
              <div class="macbody">
                <div class="face-one">
                  <div class="touchpad"></div>
                  <div class="keyboard">
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key space"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                    <div class="key f"></div>
                  </div>
                </div>
                <div class="pad one"></div>
                <div class="pad two"></div>
                <div class="pad three"></div>
                <div class="pad four"></div>
              </div>
            </div>
            <div class="shadow"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
